import { VenueDoc } from 'Shared/model/venue';
import {createContext,useContext} from 'solid-js';

const VenueContext = createContext();

export function VenueProvider(P:{value:VenueDoc})
{
	return (
		<VenueContext.Provider value={P.value}>
			{P.children}
		</VenueContext.Provider>
	);
}

export function useVenue()
{
	return useContext(VenueContext) as VenueDoc;
}

